{
  "bulkApplyConfirm": {
    "buttons": {
      "applying": "Aplicando",
      "cancel": "Cancelar",
      "confirm": "Confirmar"
    },
    "helperText": "Texto de ayuda",
    "loading": "Cargando",
    "message": "Confirmar aplicación masiva",
    "summary": {
      "alreadyMapped": "Ya asignado",
      "newMappings": "Nuevas asignac.",
      "totalRows": "Total de filas"
    },
    "title": "Confirmar aplicación masiva"
  },
  "flightBridgeStatus": {
    "pendingTenants": {
      "allMatched": "Todo coincide",
      "buttons": {
        "refresh": "Actualizar",
        "removeAndRetry": "Eliminar y reintentar"
      },
      "columns": {
        "aircraftType": "Tipo de aeronave",
        "created": "Creado",
        "fbo": "FBO",
        "operator": "Operador",
        "source": "Origen",
        "tailNumber": "Matrícula"
      },
      "description": "Descripción",
      "dialog": {
        "autoRetry": {
          "description": "Descripción",
          "title": "Reintentar"
        },
        "buttons": {
          "cancel": "Cancelar",
          "removeAndRetry": "Eliminar y reintentar",
          "removing": "Eliminando"
        },
        "message": "Diálogo",
        "reQuarantine": "Volver a cuarentena",
        "title": "Diálogo"
      },
      "errors": {
        "resolveFailed": "Error: Resolución fallida"
      },
      "noPendingTenants": "Sin inquilinos pendientes",
      "pendingCount": "Pendientes",
      "selectedCount": "Seleccionados",
      "title": "Inquilinos pendientes",
      "unknownFBO": "FBO desconocido",
      "unknownOperator": "Operador desconocido",
      "unknownType": "Tipo desconocido"
    }
  },
  "obstacleEdit": {
    "buttons": {
      "cancel": "Cancelar",
      "create": "Crear",
      "save": "Guardar"
    },
    "errors": {
      "fileSizeLimit": "Error: Límite de archivo",
      "fileTypeInvalid": "Error: Tipo de archivo no válido"
    },
    "helperText": {
      "keepCurrent": "Mantener actual"
    },
    "image": {
      "changeButton": "Cambiar botón",
      "preview": "Previsual.",
      "selected": "Seleccionado",
      "uploadButton": "Botón de carga"
    },
    "labels": {
      "height": "Altura",
      "length": "Longitud",
      "name": "Nombre",
      "obstacleImage": "Imagen del obstáculo",
      "width": "Ancho"
    },
    "placeholders": {
      "height": {
        "create": "Crear",
        "edit": "Editar"
      },
      "length": {
        "create": "Crear",
        "edit": "Editar"
      },
      "name": {
        "create": "Crear"
      },
      "width": {
        "create": "Crear",
        "edit": "Editar"
      }
    },
    "title": {
      "create": "Crear",
      "edit": "Editar"
    }
  },
  "towingEquipmentEdit": {
    "buttons": {
      "cancel": "Cancelar",
      "create": "Crear",
      "save": "Guardar"
    },
    "helperText": {
      "keepCurrent": "Mantener actual",
      "noFootprint": "Sin dimensiones"
    },
    "labels": {
      "height": "Altura",
      "length": "Longitud",
      "name": "Nombre",
      "noFootprint": "Sin dimensiones",
      "towBar": "Remolque",
      "width": "Ancho"
    },
    "placeholders": {
      "height": {
        "create": "Crear",
        "edit": "Editar"
      },
      "length": {
        "create": "Crear",
        "edit": "Editar"
      },
      "name": {
        "create": "Crear"
      },
      "towBar": {
        "create": "Crear",
        "edit": "Editar"
      },
      "width": {
        "create": "Crear",
        "edit": "Editar"
      }
    },
    "title": {
      "create": "Crear",
      "edit": "Editar"
    }
  }
}
